import { render } from "./Overview.vue?vue&type=template&id=c08d9af6&scoped=true&lang=pug"
import script from "./Overview.vue?vue&type=script&lang=js"
export * from "./Overview.vue?vue&type=script&lang=js"

import "./Overview.vue?vue&type=style&index=0&id=c08d9af6&lang=scss&scoped=true"
import "./Overview.vue?vue&type=style&index=1&id=c08d9af6&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c08d9af6"]])

export default __exports__